import { ChatMessageAttachmentType } from "@jugl-web/rest-api";
import { TFunction } from "@jugl-web/utils";

export const getAttachmentsCountLabel = (
  attachmentType: ChatMessageAttachmentType,
  count: number,
  t: TFunction
) => {
  switch (attachmentType) {
    case ChatMessageAttachmentType.image:
      return t(
        {
          id: "chats-page.images-count",
          defaultMessage: "{count} {count, plural, one {Image} other {Images}}",
        },
        { count }
      );

    case ChatMessageAttachmentType.video:
      return t(
        {
          id: "chats-page.videos-count",
          defaultMessage: "{count} {count, plural, one {Video} other {Videos}}",
        },
        { count }
      );

    case ChatMessageAttachmentType.audio:
      return t(
        {
          id: "chats-page.audios-count",
          defaultMessage: "{count} {count, plural, one {Audio} other {Audios}}",
        },
        { count }
      );

    default:
      return t(
        {
          id: "chats-page.files-count",
          defaultMessage: "{count} {count, plural, one {File} other {Files}}",
        },
        { count }
      );
  }
};
